import { Box, CircularProgress } from '@mui/material';

import { useGlobalUXStore } from '@src/store';

export default function GlobalLoadingSpinner() {
	const { isLoading } = useGlobalUXStore((store) => store);
	if (!isLoading) return null;
	return (
		<Box
			sx={{
				position: 'fixed',
				top: 0,
				left: 0,
				height: '100%',
				width: '100%',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<CircularProgress color="secondary" />
		</Box>
	);
}
